import { useTranslation } from 'react-i18next';

export default function Cookies() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">{t('cookies.title')}</h1>
          
          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookies.introduction.title')}</h2>
              <p className="text-gray-700 mb-4">{t('cookies.introduction.description')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookies.whatAreCookies.title')}</h2>
              <p className="text-gray-700 mb-4">{t('cookies.whatAreCookies.description')}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookies.typesOfCookies.title')}</h2>
              <ul className="list-disc pl-6 space-y-4">
                <li>
                  <h3 className="text-xl font-medium text-gray-900">{t('cookies.typesOfCookies.essential.title')}</h3>
                  <p className="text-gray-700">{t('cookies.typesOfCookies.essential.description')}</p>
                </li>
                <li>
                  <h3 className="text-xl font-medium text-gray-900">{t('cookies.typesOfCookies.analytics.title')}</h3>
                  <p className="text-gray-700">{t('cookies.typesOfCookies.analytics.description')}</p>
                </li>
                <li>
                  <h3 className="text-xl font-medium text-gray-900">{t('cookies.typesOfCookies.functional.title')}</h3>
                  <p className="text-gray-700">{t('cookies.typesOfCookies.functional.description')}</p>
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('cookies.cookieControl.title')}</h2>
              <p className="text-gray-700 mb-4">{t('cookies.cookieControl.description')}</p>
              <ul className="list-disc pl-6 space-y-2">
                {['chrome', 'firefox', 'safari', 'edge'].map((browser) => (
                  <li key={browser} className="text-gray-700">
                    {t(`cookies.cookieControl.browsers.${browser}`)}
                  </li>
                ))}
              </ul>
            </section>

            {/* <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('contact.title')}</h2>
              <p className="text-gray-700 mb-2">{t('contact.description')}</p>
              <p className="text-gray-700">{t('contact.email')}</p>
            </section>

            <section className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600">{t('lastUpdated')}</p>
            </section> */}
          </div>
        </div>
      </div>
    </div>
  );
}
